import GroupAddOutlinedIcon from "@mui/icons-material/GroupAddOutlined";
import { Button, FormControlLabel, Switch } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

const StyledPageToolbar = styled("div")(() => ({
    marginBottom: "20px",
    marginTop: "20px",
    justifyContent: "space-between",
    alignItems: "center",
    display: "flex",
}));
const StyledButtonsContainer = styled("div")(() => ({
    display: "flex",
    alignItems: "center",
}));
const StyledInactiveText = styled("div")(() => ({
    fontSize: "14px",
    paddingRight: "25px",
}));

const AdminToolbar = (props) => {
    const { handleInputChange, handleSaveAccountUpdates, userAccount, toggleAddProxy } = props;

    const navigate = useNavigate();

    const handleCancel = () => {
        navigate("/admin/users");
    };

    return (
        <StyledPageToolbar container justifyContent="space-between" alignItems="center" spacing={16}>
            <h2 className="page-title">Edit User Account</h2>
            <StyledButtonsContainer style={{}}>
                {userAccount?.activeFlg === false && userAccount?.inactiveDate && (
                    <StyledInactiveText>Inactivated On: {userAccount?.inactiveDate}</StyledInactiveText>
                )}
                <FormControlLabel
                    control={
                        <Switch
                            checked={userAccount.activeFlg ? true : false}
                            onChange={(e) => handleInputChange("userAccount.activeFlg", e.target.checked)}
                            color="primary"
                            disabled={false}
                        />
                    }
                    label="Active"
                />
                <Button
                    disabled={userAccount?.allowedProxies === undefined}
                    sx={{ color: "black" }}
                    startIcon={<GroupAddOutlinedIcon sx={{ color: "grey" }} />}
                    onClick={toggleAddProxy}
                    data-testid="proxies-toolbar-button"
                >
                    Proxies
                </Button>
                <Button variant="outlined" color="primary" onClick={handleCancel}>
                    Cancel
                </Button>
                <Button color="primary" variant="contained" onClick={handleSaveAccountUpdates}>
                    Save
                </Button>
            </StyledButtonsContainer>
        </StyledPageToolbar>
    );
};

export default AdminToolbar;
